import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/pace-calculator',
  component: () => import('../../routes/PaceCalculator.svelte'),
  card: {
    id: 'pace-calculator',
    title: 'Pace Calculator',
    description: 'Calculate running or cycling pace, time, or distance. Enter any two values to find the third — supports both miles and kilometers.',
    icon: 'directions_run',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/pace-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Pace Calculator – Running & Cycling Pace Calculator',
    description:
      'Free pace calculator for runners and cyclists. Calculate your pace per mile or per km, total time, or distance. Supports 5K, 10K, half marathon, and marathon pace predictions.',
  },
};

export default meta;
